import { createSelector } from 'reselect';

export const healthSelector = (state) => state.health;

export const payProHealthSelector = createSelector(
    healthSelector,
    (health) => health.payPro,
);
